import { InputAdornment, styled, TextField } from "@mui/material";

const TextInput = ({
  placeholder,
  onChange,
  value,
  disabled,
  multiline,
  startAdornment,
  endAdornment,
  inputMode,
  rows,
  label,
  required,
  width,
  error,
  helperText,
  inputStyle,
  autoComplete,
  readOnly,
  ...rest
}) => {
  return (
    <CustomTextField
      customWidth={width}
      size="small"
      placeholder={placeholder}
      onChange={onChange}
      value={value}
      disabled={disabled}
      multiline={multiline}
      rows={rows}
      InputProps={{
        autoComplete: autoComplete,
        startAdornment: startAdornment && (
          <InputAdornment position="start">{startAdornment}</InputAdornment>
        ),
        endAdornment: endAdornment && (
          <InputAdornment position="end">{endAdornment}</InputAdornment>
        ),
        inputMode,
        readOnly: readOnly,
      }}
      InputLabelProps={{
        shrink: value ? true : undefined,
      }}
      label={label}
      required={required}
      fullWidth
      error={error}
      helperText={helperText}
      inputStyle={inputStyle}
      {...rest}
    />
  );
};
const CustomTextField = styled(TextField)(({ customWidth, inputStyle }) => ({
  width: customWidth,
  "& .MuiOutlinedInput-root.Mui-disabled": {
    backgroundColor: "#F3F4F6",
    cursor: "not-allowed",
  },
  "& .MuiOutlinedInput-input": {
    ...inputStyle,
    "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    "&[type=number]": {
      "-moz-appearance": "textfield",
    },
  },
}));

export default TextInput;
